import * as Yup from 'yup'
import { formErrors } from '../../errors.constants'

export const editApiKeyFormValidationSchema = Yup.object().shape({
  label: Yup.string().required(formErrors.required),
})
